<rdo-chart-export-buttons [config]="chartConfig"></rdo-chart-export-buttons>
<div class="active tab-pane" style="padding-top: 5px" [rdo-highcharts]="chartConfig" [useVendorExport]="false"></div>